import "@fontsource/outfit";

require('prismjs/themes/prism.css')
